import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import AsyncSelect from 'react-select/async';
import EmailReminderButton from "../components/EmailReminderButton";
import EmailEveryoneButton from "../components/EmailEveryoneButton";
import { useApi } from "../hooks/useApi";
import InfoTooltip from "../components/ui/InfoTooltip";

export default function EmailTemplates() {
  const initialized = useRef(false);
  const { apiCall } = useApi();
  const [emailData, setEmailData] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedSites, setSelectedSites] = useState([]);
  const [inProgress, setInProgress] = useState(false);
  const [currentEmailId, setCurrentEmailId] = useState(false);
  const emailTypeLabels = {
    coding_sheet_published_users: 'Users - New Coding Sheet Published',
    reminder_users: 'Users - Reminder Notification',
    deadline_admin: 'Admins - Deadline Alert',
    users_invalid_gate_number: 'Users - No Valid Gate Three Sub-PO #',
    users_urgent_reminder: 'Users - Urgent Reminder',
    general_email: 'Users - Email Everyone',
  };
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      apiCall(`fetch_email_templates`)
        .then((response) => response.json())
        .then((data) => {
          setEmailData(data); // data should be an array
        })
        .catch((error) => {
          console.error('Error:', error);
          setEmailData([]); // Fallback to empty array on error
        });


    }
  }, []);
  const sendEmail = () => {
    if (selectedSites.length < 1) {
      alert('Select some sites first');
      return;
    }
    if (!currentEmailId) {
      alert('email type missing');
      return;
    }

    if (inProgress) return;
    setInProgress(true);

    const site_ids = selectedSites.map(site => site.value);
    apiCall(`sendCustomEmailToSites`, {
      method: "POST",
      body: { site_ids: site_ids, email_type: currentEmailId },
    }).then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setIsDialogOpen(false);
          setCurrentEmailId(false);
          setSelectedSites([]);
          if (data.message) {
            alert(data.message);
          }
        } else {

          if (data.error) {
            alert(data.error);
          }
          else {
            alert("Error setting up the reminder.");
          }

        }

      }).finally((data) => {
        setInProgress(false);

      });

  };
  const loadSiteOptions = async (inputValue, callback) => {
    if (!inputValue) return callback([]);
    try {
      const response = await apiCall(`search_sites`, { params: { search_term: inputValue } });
      const data = await response.json();
      const options = data.map(site => ({
        value: site.id,
        label: `${site.site_number} - ${site.site_name}`
      }));
      callback(options);
    } catch (error) {
      console.error("Error loading sites", error);
      callback([]);
    }
  };

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Email Templates</h1>
      </div>
      <div className="font-bold mb-4 italic">(Emails only go out to users that have emails enabled in the settings.)</div>
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2 w-100">Email Type</th>
            <th className="border p-2">Subject</th>
            <th className="border p-2"></th>
          </tr>
        </thead>
        <tbody>

          {emailData.map((email) => (
            <tr className="border" key={email.id}>
              <td className="border p-2">
                <div className="flex items-center justify-between">

                  <Link to={`/edit-template/${email.id}`} className="text-blue-600 hover:underline">

                    {emailTypeLabels[email.type] || email.type}

                  </Link>
                  <Link to={`/edit-template/${email.id}`} className="text-blue-600 hover:underline">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                    </svg>
                  </Link>
                </div>
              </td>
              <td className="border p-2" >
                {
                  email.subject
                }
              </td>

              <td className="border p-2" >
                {email.type == 'users_invalid_gate_number' && (
                  <div className="text-gray-700 font-medium mb-2 text-center">
                    <button
                      onClick={() => { setIsDialogOpen(true); setCurrentEmailId(email.type); }}
                      className="bg-green-500  text-white px-4 py-2 rounded mt-4 cursor-pointer disabled:opacity-50 }"
                    >
                      Send Manual Email
                    </button>
                  </div>

                )}

                {email.type == 'reminder_users' && (
                  <p>A reminder to uncoded sites every 5 days</p>
                )}
                {email.type == 'coding_sheet_published_users' && (
                  <p>For the projects with new coding sheets.</p>
                )}
                {email.type == 'users_urgent_reminder' && (

                  <EmailReminderButton />
                )}
                {email.type == 'general_email' && (

                  <EmailEveryoneButton />
                )}
                {email.type == 'deadline_admin' && (
                  <p>Email admins a day before the deadline.</p>
                  //<InfoTooltip text="For admin users only" />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ConfirmDialog
        open={isDialogOpen}
        title="Email Setup"
        message={
          <>
            <div className="mb-3">Select sites to send email to:</div>
            <AsyncSelect
              isMulti
              loadOptions={loadSiteOptions}
              defaultOptions
              onChange={setSelectedSites}
              value={selectedSites}
              placeholder="Search job sites..."
            />
          </>

        }
        inProgress={inProgress}
        confirmText="Submit"
        cancelText="Cancel"
        onConfirm={sendEmail}
        onCancel={() => {
          setIsDialogOpen(false);
          setSelectedSites([]);
          setCurrentEmailId(false);
        }}
      />
    </div>
  );
}
